<template>
  <Modal
    data-testid="client-resource-modal"
    :show="show"
    role="alertdialog"
    size="2xl"
  >
    <form
      class="mx-auto bg-white dark:bg-gray-800 rounded-lg shadow-lg overflow-hidden"
    >
      <slot>
        <ModalHeader v-text="'Załączniki'" />
        <ModalContent>
          <p class="leading-normal">
              
                <template v-for="field in resourceModal.fields">
                 <template v-if="field.component == 'advanced-media-library-field' && field.attribute == 'agreement'">
                   <div class="flex flex-wrap ">
                      <div class="md:w-full pr-4 pl-4">  
                        <strong>{{field.name}}</strong>
                      </div>
                    </div>
                   <div v-if="field.type === 'media'">
                        <div class="flex flex-wrap mb-8">
                            <template v-for="img in field.value">
                                <div class="md:w-1/4 pr-4 pl-4">
                                    <a v-if="img" :href="img.original_url" target="_blank">
                                      <img
                                        v-if="img"
                                        :src="img.__media_urls__.detailView"
                                        style="object-fit: cover"
                                        class="w-120 h-120"
                                      /></a>
                                </div>
                            </template>
                        </div>
                  </div>
                        <div v-else>
                                      <span v-if="field.multiple">
                                        {{ field.value.map(({ file_name }) => file_name).join(', ') }}
                                      </span>
                                      <span v-else>
                                        {{ field.value[0].file_name }}
                                      </span>
                        </div>
                    </template>
                </template>
                  
              <template v-for="field in resourceModal.fields">
                 <template v-if="field.component == 'advanced-media-library-field' && field.attribute == 'photo'">
                  
                      <div class="flex flex-wrap "> 
                       <div class="md:w-full pr-4 pl-4">  
                          <strong>{{field.name}}</strong>
                       </div>
                    </div>
            <div v-if="field.type === 'media'">
                            <div class="flex flex-wrap ">
                                <template v-for="img in field.value">
                                  <div class="md:w-1/4 pr-4 pl-4">
                                        <a v-if="img" :href="img.original_url" target="_blank">
                                      <img
                                        v-if="img"
                                        :src="img.__media_urls__.detailView"
                                        style="object-fit: cover"
                                        class="w-120 h-120"
                                      /></a>
                                    </div>
                                </template>
                                
                            </div>
                        
                    </div>
                                    <div v-else>
                                      <span v-if="field.multiple">
                                        {{ field.value.map(({ file_name }) => file_name).join(', ') }}
                                      </span>
                                      <span v-else>
                                        {{ field.value[0].file_name }}
                                      </span>
                                    </div>
                     </template>
                </template>

                            
        
          </p>
        </ModalContent>
      </slot>

      <ModalFooter>
        <div class="ml-auto">
          <LinkButton
            type="button"
            data-testid="cancel-button"
            dusk="cancel-delete-button"
            @click.prevent="handleClose"
            class="mr-3"
          >
            {{ __('Cancel') }}
          </LinkButton>

          
        </div>
      </ModalFooter>
    </form>
  </Modal>
</template>

<script>
import startCase from 'lodash/startCase'

export default {

  emits: ['confirm', 'close'],

  props: {
    show: { type: Boolean, default: false },

    resourceModal: {
      default: null,
    },
  },

  data: () => ({
    working: false,
  }),

  methods: {
    handleClose() {
      this.$emit('close')
      this.working = false
    },

    
    
  },

  /**
   * Mount the component.
   */
  mounted() {
    this.$nextTick(() => {
      // this.$refs.confirmButton.button.focus()
    })
  },

  computed: {
    uppercaseMode() {
      return startCase(this.mode)
    },

  },
}
</script>
